import React from "react";
import clsx from "clsx";
import Button from "@/shared/ui/button/Button";

type Props = {
  onClick: () => void;
  className?: string;
  active?: boolean;
  children: React.ReactNode;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseUp?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export default function CreateCharacterBtn({
  onClick,
  className,
  active,
  children,
  ...props
}: Props) {
  return (
    <Button
      onClick={onClick}
      {...props}
      icon
      variant={null}
      color={null}
      className={clsx(
        "h-9",
        active
          ? "variant-accent variant-solid-gradient"
          : "variant-matched variant-solid hover-variant-accent hover-variant-solid-gradient",
        className,
      )}
    >
      {children}
    </Button>
  );
}
